import React from 'react';
import { Card, Col, Row } from 'antd';

interface QueueStats {
  total_queues: number;
  total_jobs: number;
  queued: number;
  running: number;
  completed: number;
  failed: number;
}

interface StatCardsProps {
  stats: QueueStats;
}

export const StatCards: React.FC<StatCardsProps> = ({ stats }) => {
  return (
    <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
      <Col span={4}>
        <Card size="small">
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 24, fontWeight: 'bold' }}>{stats.total_queues}</div>
            <div style={{ fontSize: 12, color: '#666' }}>Queues</div>
          </div>
        </Card>
      </Col>
      <Col span={4}>
        <Card size="small">
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 24, fontWeight: 'bold' }}>{stats.total_jobs}</div>
            <div style={{ fontSize: 12, color: '#666' }}>Total Jobs</div>
          </div>
        </Card>
      </Col>
      <Col span={4}>
        <Card size="small">
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 24, fontWeight: 'bold', color: '#999' }}>{stats.queued}</div>
            <div style={{ fontSize: 12, color: '#666' }}>Queued</div>
          </div>
        </Card>
      </Col>
      <Col span={4}>
        <Card size="small">
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 24, fontWeight: 'bold', color: '#1890ff' }}>{stats.running}</div>
            <div style={{ fontSize: 12, color: '#666' }}>Running</div>
          </div>
        </Card>
      </Col>
      <Col span={4}>
        <Card size="small">
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 24, fontWeight: 'bold', color: '#52c41a' }}>{stats.completed}</div>
            <div style={{ fontSize: 12, color: '#666' }}>Completed</div>
          </div>
        </Card>
      </Col>
      <Col span={4}>
        <Card size="small">
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 24, fontWeight: 'bold', color: '#ff4d4f' }}>{stats.failed}</div>
            <div style={{ fontSize: 12, color: '#666' }}>Failed</div>
          </div>
        </Card>
      </Col>
    </Row>
  );
};